// types
import { Comment } from '../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// ui
import { Table, TableHeader, TableProps } from '../../../ui/Table/Table';

// headers
import { getHeaders } from './TableBasicComments.headers';

// props
export interface TableBasicCommentsProps extends Omit<TableProps, 'headers'> {
	data: Comment[];
}

export const TableBasicComments = ({ data = [], ...props }: TableBasicCommentsProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	const headers: TableHeader[] = getHeaders({ t });

	return <Table {...props} headers={headers} data={data} />;
};
